module.exports = __webpack_public_path__ + "svg/hearts.svg?167fefff038ba689ed8babecfd29c0de";